const theme = {
  color: {
    lightGray: "#F5F5F5",
    blue: "#2196f3",
    red: "#E30613",
    white: "#FFFFFF",
    black: "#000000",
    headerFooterBg: "#091535",
    ctaActionLink: "#0074E0",
    text: "#374D62",
    radioLabel: "#043074",
    gray: "#506376",
    darkBlue: "#42566B",
    specificTextColor: "#070B16",
    modalText: "#1D2948",
    bannerText: "#47526B",
  },
};

export default theme;
